import Prism from 'prismjs';

// Highlight all matching syntax
Prism.highlightAll();

global.$ = global.jQuery = require('jquery');

// Redirect to login on expired sessions for all jQuery AJAX calls (DataTables, Editor, etc.)
$(document).ajaxError(function (event, xhr) {
    if (xhr.status === 401 && !window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
    }
});

import DataTable from 'datatables.net-dt';
import Editor from '@datatables.net/editor-dt';
import 'datatables.net-buttons-dt';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-colreorder-dt';
import 'datatables.net-fixedcolumns-dt';
import 'datatables.net-keytable-dt';
import 'datatables.net-select-dt';

import 'datatables.net-plugins/dataRender/ellipsis.mjs';

// default layout for all tables
DataTable.defaults.layout = {
    topStart: {
        features: [
            {
                pageLength: {
                    text: '_MENU_ records',
                },
            },
            'buttons',
        ],
    },
    bottomStart: 'info',
    bottomEnd: 'paging',
};

// Default class modification
$.extend(true, DataTable.ext.classes, {
    container: 'dt-container',
});

window.DataTable = DataTable;

document.addEventListener('alpine:init', () => {
    Alpine.magic('relativeTime', () => (iso) => {
        const diffMs = new Date(iso) - new Date();
        const abs = Math.abs(diffMs);
        const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

        if (abs < 60_000) return rtf.format(Math.round(diffMs / 1_000), 'second');
        if (abs < 3_600_000) return rtf.format(Math.round(diffMs / 60_000), 'minute');
        if (abs < 86_400_000) return rtf.format(Math.round(diffMs / 3_600_000), 'hour');
        if (abs < 604_800_000) return rtf.format(Math.round(diffMs / 86_400_000), 'day');
        if (abs < 2_592_000_000) return rtf.format(Math.round(diffMs / 604_800_000), 'week');
        return rtf.format(Math.round(diffMs / 2_592_000_000), 'month');
    });
});
